module.exports = __webpack_public_path__ + "static/stava_img_3-ff7d389732679ce59022d32e8fe862fb.png";